import { lazy, Suspense } from 'react';

import { HeaderSection, HeroSection, StickyCallDock } from './domains/hire';
import { DemoPreviewBanner } from './shared/components/DemoPreviewBanner';
import { JmrSquaredAttribution } from './shared/components/JmrSquaredAttribution';
import { useAfterFirstPaint } from './shared/hooks/useAfterFirstPaint';

const HireStorySection = lazy(async () => {
  const module = await import('./domains/hire/sections/HireStorySection');
  return { default: module.HireStorySection };
});
const FleetSection = lazy(async () => {
  const module = await import('./domains/hire/sections/FleetSection');
  return { default: module.FleetSection };
});
const ProcessSection = lazy(async () => {
  const module = await import('./domains/hire/sections/ProcessSection');
  return { default: module.ProcessSection };
});
const YardProofSection = lazy(async () => {
  const module = await import('./domains/hire/sections/YardProofSection');
  return { default: module.YardProofSection };
});
const TrustSection = lazy(async () => {
  const module = await import('./domains/hire/sections/TrustSection');
  return { default: module.TrustSection };
});
const ContactSection = lazy(async () => {
  const module = await import('./domains/hire/sections/ContactSection');
  return { default: module.ContactSection };
});
const FooterSection = lazy(async () => {
  const module = await import('./domains/hire/sections/FooterSection');
  return { default: module.FooterSection };
});

function SectionFallback() {
  return <div className="min-h-[40vh] bg-surface" aria-hidden="true" />;
}

export function App() {
  const painted = useAfterFirstPaint();

  // `overflow-x-clip` rather than `-hidden`: hidden would make this a scroll container
  // and break every `position: sticky` descendant. See the note in `index.css`.
  return (
    <div className="min-h-screen overflow-x-clip bg-surface pb-24 text-neutral-900">
      {/* Banner and nav pin as one stack: a fixed offset cannot track the banner's
          height, which wraps to two lines on a phone and overlapped the nav by 31px. */}
      <div className="sticky top-0 z-[60]">
        <DemoPreviewBanner />
        <HeaderSection />
      </div>
      <main>
        <HeroSection />
        <Suspense fallback={<SectionFallback />}>
          {painted ? (
            <>
              <HireStorySection />
              <FleetSection />
              <ProcessSection />
              <YardProofSection />
              <TrustSection />
              <ContactSection />
              <FooterSection />
            </>
          ) : (
            <SectionFallback />
          )}
        </Suspense>
      </main>
      <JmrSquaredAttribution />
      <StickyCallDock />
    </div>
  );
}
